"use strict";

(function (Drupal) {
  Drupal.behaviors.hslBlock = {
    attach: function attach(context, settings) {
      var hslBlock = context.querySelector('.block-hsl');
      var body = document.body;
      if (!hslBlock || body.classList.contains('layout-builder--is-enabled')) {
        return;
      }
      var mql = window.matchMedia('screen and (min-width: 64rem)');

      // suppress tooltip
      hslBlock.querySelectorAll('a').forEach(function (links) {
        links.removeAttribute('title');
      });

      // gsap wrapper
      var wrap = gsap.utils.wrap(0, 1);

      /*
       * Horizontal scrolling links
       */
      hslBlock.querySelectorAll('.block-hsl__links > div').forEach(function (ticker) {
        var innerItems = ticker.querySelector('.field__items');
        var windowWidth = window.innerWidth > 1920 ? 1920 : window.innerWidth;
        var totalDist = innerItems.offsetWidth - windowWidth;
        var tickerDir = ticker.dataset.direction;
        var anim;
        var startPos;
        var bounds = {
          minX: -totalDist,
          maxX: 0
        };
        if (tickerDir === 'right' && mql.matches) {
          bounds = {
            minX: 0,
            maxX: totalDist
          };
        }

        // make container touchable via gsap draggable
        var draggableHSL = new Draggable(ticker, {
          type: 'x',
          trigger: ticker,
          throwProps: false,
          bounds: bounds,
          onPressInit: function onPressInit() {
            anim.pause();
            startPos = this.x;
          },
          onDrag: function onDrag() {
            var prog = wrap(-this.x / totalDist);
            if (tickerDir === 'right' && mql.matches) {
              prog = wrap(-this.x / -totalDist);
            }
            anim.progress(prog);
          },
          onDragEnd: function onDragEnd() {
            if (mql.matches) {
              anim.play();
              gsap.fromTo(anim, {
                timeScale: 0
              }, {
                timeScale: 1,
                ease: 'power1.in'
              });
            }
          }
        });

        // basic GSAP animation to enact the scrolling links
        var initHSL = function initHSL() {
          var xDir;
          tickerDir == 'left' ? xDir = -totalDist : xDir = +totalDist;
          if (!mql.matches) {
            xDir = 0;
          }
          if (anim && mql.matches) anim.play(0);
          anim = gsap.to(ticker, {
            duration: mql.matches ? 80 : 0,
            x: xDir,
            ease: 'none',
            repeat: -1,
            overwrite: true
          });
        };

        // init
        initHSL();

        // resize
        window.addEventListener('resize', initHSL);
        if (mql.matches) {
          // animate only when in viewport
          var observer = new IntersectionObserver(function (linkGroup, observer) {
            linkGroup.forEach(function (item) {
              item.isIntersecting ? anim.play() : anim.pause();
            });
          }, {
            rootMargin: '0px 0px -300px 0px'
          });
          hslBlock.querySelectorAll('.block-hsl__links > div').forEach(function (item) {
            observer.observe(item);
          });

          // mouse events
          ticker.addEventListener('mouseenter', function () {
            anim.pause();
          });
          ticker.addEventListener('mouseleave', function () {
            anim.play();
            gsap.fromTo(anim, {
              timeScale: 0
            }, {
              timeScale: 1,
              ease: 'power1.in'
            });
          });
        } else {
          anim.pause();
        }
      });
    }
  };
})(Drupal);